// extracted by mini-css-extract-plugin
export default {"table-wrapper":"A-gqwBFFUUH36jzO8ISxmQ==","message":"_6pd12o2S12I+z-dJvrygyw=="};